import { useState } from "react"
import { BelizConfirmationForm } from "./BelizConfirmationForm";

export const BelizSignAnketaForm = () => {
    return (<BelizConfirmationForm/>)
}